import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal } from "./Reveal";
import { OUTCOMES } from "@/data/exceptionHub";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export const Outcomes = () => {
  return (
    <section id="outcomes" className="relative py-24 md:py-32 bg-canvas-soft" data-testid="section-outcomes">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><span className="text-xs font-semibold uppercase tracking-[0.15em] text-brand">Business Outcomes</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-navy tracking-tight leading-tight text-balance">
              Operational confidence you can measure.
            </h2>
          </Reveal>
        </div>

        <motion.div variants={stagger(0.07)} initial="hidden" whileInView="show" viewport={viewport}
          className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {OUTCOMES.map((o) => {
            const Icon = Icons[o.icon] || Icons.Circle;
            return (
              <motion.article key={o.title} variants={fadeUp} whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 300, damping: 24 }}
                data-testid={`outcome-card-${o.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group rounded-2xl bg-white border border-slate-100 shadow-soft hover:shadow-card transition-shadow p-7 md:p-8">
                <span className="grid place-items-center h-12 w-12 rounded-2xl bg-brand-soft text-brand group-hover:scale-110 transition-transform">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </span>
                <h3 className="mt-6 font-heading text-xl font-semibold text-navy tracking-tight">{o.title}</h3>
                <p className="mt-3 text-ink-500 leading-relaxed">{o.desc}</p>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
